<template>
<div class="monitor-container"> 
<div class="opport-screen-list1">
    <dl class="opport-screen bdbe"  v-show="type == 1"> 
        <dt class="fl">关键词查询</dt>
        <dd class="fl">
            <div class="fl search-box right_boxtitle">
                <span class="searchtype">项目名称查询</span>
                <input type="text" placeholder="请输入项目关键词" class="search-input" v-model="searchtext"
                    @keydown="searchenter" />
                 <button class="search-btn" @click="searchkwfun">查询</button>
            </div>
            <div class="fl search-box right_boxtitle ml-6">
                <span class="searchtype">企业名称查询</span>
                <input type="text" placeholder="请输入企业名称关键词" class="search-input" v-model="searchtext"
                    @keydown="searchenter" />
                 <button class="search-btn" @click="searchkwfun">查询</button>
            </div>
        </dd>
    </dl>
    <!-- 概念 -->
     <notionScreen v-show="type == 2" :type="1" :isShowFutureIndustries="true" :isIntegration="true" :notionNumList='[]'
        :showNotionCodeList="{}" :showNotionExtend="true" :token="userdata.token"
        @chooseNotion="chooseNotion" :isShowNotionScreen="true"></notionScreen>
    <dl class="opport-screen bdbe" v-show="type == 3">
        <dt class="fl">企业类型</dt>
        <dd class="fl">
            <span :class="enterpriseType == list.id ? 'a-screen current' : 'a-screen'" @click="chooseFilter(list, 'enterprise')" :key="i"
                v-for="(list, i) in enterpriseTypeList">{{ list.name }}</span>
        </dd>
    </dl>
    <dl class="opport-screen bdbe">
        <dt class="fl">投资金额</dt>
        <dd class="fl">
            <!-- <span :class="landSize == 0 ? 'a-screen current' : 'a-screen'"
                @click="chooseSize({ value: 0, paraName: '全部' }, 2)">全部</span> -->
            <span :class="investMoney == list.value ? 'a-screen current' : 'a-screen'" @click="chooseFilter(list, 'money')" :key="i"
                v-for="(list, i) in investMoneyList">{{ list.paraName }}</span>
        </dd>
    </dl>
    <dl class="opport-screen bdbe">
        <dt class="fl">投资时间</dt>
        <dd class="fl">
            <span :class="contractTime == list.value ? 'a-screen current' : 'a-screen'" @click="chooseFilter(list, 'contract')" :key="i"
                v-for="(list, i) in contractTimeList">{{ list.paraName }}</span>
        </dd>
    </dl>
    <dl class="opport-screen bdbe">
        <dt class="fl">投资模式</dt>
        <dd class="fl">
            <span :class="investMode == list.value ? 'a-screen current' : 'a-screen'" @click="chooseFilter(list, 'investMode')" :key="i"
                v-for="(list, i) in investModeList">{{ list.paraName }}</span>
        </dd>
    </dl>
    <notionScreen v-show="type == 1" :type="1" :isShowFutureIndustries="true" :isIntegration="true" :notionNumList='[]'
        :showNotionCodeList="{}" :showNotionExtend="true" :token="userdata.token"
        @chooseNotion="chooseNotion" :isShowNotionScreen="true"></notionScreen>
    <!-- 省市区筛选 -->
    <cityScreen v-show="type == 1" @getEnterpriseList="cityScreenFun"></cityScreen>
</div>
</div>
</template>
<script>
export default {
    name: 'Monitor',
    data() {
        return {
            searchtext: '',
            size: 10,
            page: 1,
            total: 0,
            investMoney: 0,
            investMoneyList    : [
                { value: 0, paraName: '全部' },
                { value: 1, paraName: '0-5亿' },
                { value: 2, paraName: '5-10亿' },
                { value: 3, paraName: '10-50亿' },
                { value: 4, paraName: '50-100亿' },
                { value: 5, paraName: '100亿以上' },
            ],
            investModeList: [
                { value: 0, paraName: '全部' },
                { value: 1, paraName: '独立投资' },
                { value: 2, paraName: '合资经营' },
                { value: 3, paraName: ' 股权投资 ' },
                { value: 3, paraName: ' 并购' },
                { value: 3, paraName: ' 增资' },
            ],
            investMode: 0,
            volumeUpper: 0,
            contractTimeList: [
                { value: 0, paraName: '全部' },
                { value: 1, paraName: '0-3月前' },
                { value: 2, paraName: '4-6月前' },
                { value: 3, paraName: '7-9月前' },
                { value: 4, paraName: '10-12月前' },
                { value: 4, paraName: '1年以上'}
            ],
            contractTime: 0,
            cityid: '',
            countyid: '',
            provinceid: '',
            userdata: {},
            notionCode: '',
            chooseNotionlist: [],
            enterpriseType: 0,
            enterpriseTypeList: [{
				name: "龙头企业库", id: 1, url: '/enterpriseList?type=9&Pt=1',
				children: [{
					ptId: 1,
					pagecode: 'A-LTQY',
					type: 9,
					name: "A股上市龙头企业", //原上市企业
					tagnum: 10010,
					hxtagname: '&企业上市标签&拿地信息&股权投资信息&财力稳健&项目投资信息'
				},
				{
					ptId: 1,
					pagecode: 'A-GGZZ',
					type: 'A090206',
					name: "港股中资企业",//
					tagnum: 10010,
					hxtagname: ''
				},
				{
					ptId: 1,
					pagecode: 'A-MGZZ',
					type: 'A090208',
					name: "美股中资企业",//
					tagnum: 10010,
					hxtagname: ''
				},
				{
					ptId: 1,
					pagecode: 'A-LTQY',
					type: 1,
					name: "非上市龙头企业",//原龙头企业
					tagnum: 10010,
					hxtagname: '&项目投资信息&拿地信息&股权投资信息&'
				},

				]
			},
			{
				name: "科创企业库", id: 2, url: '/enterpriseList?type=2&Pt=2',
				children: [{
					ptId: 2,
					pagecode: 'A-KCQY',
					type: 2,
					name: "创投企业",
					tagnum: 3,
					hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
				},
				{
					ptId: 2,
					pagecode: 'A-KCQY',
					type: 3,
					name: "优质企业",
					tagnum: 10009,
					hxtagname: '&拿地信息&股权投资信息&'
				},
				]
			}

			],

        }
    },
    props: { 
        type: Number,
    },
    mounted() {
    },
    methods: {
        //概念单选 层级显示
		chooseNotion(chooseNotionlist, notionCode) {
			// this.chooseNotionlist=chooseNotionlist;
			console.log('父组件code', notionCode);
			this.notionCode = notionCode;
			this.ajaxsearchcompany(1);
		},
        //省份城市选择 
		cityScreenFun(pid, cid, cuid) {
			this.cityid = cid;
			this.countyid = cuid;
			this.provinceid = pid;
			this.ajaxsearchcompany();
		},
        //筛选
        chooseFilter(list, type) {
            this.landSize = list.value;
        },
        //搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			if (this.searchtext.length > 0) {
				this.getList(1,'search');
			} else {
				this.$message({
					type: 'error',
					message: '请输入关键词搜索',
				});
			}
		},
        searchenter(e) {
            if (e.keyCode == 13) {
                this.searchkwfun();
            }
        },

    },
    
}
</script>
<style lang="scss">
.monitor-container .search-box{
    width: 442px;
}
</style>